export default "__VITE_ASSET__DrZ0laDS__"